<script setup>
  const { wide, full } = defineProps({ wide: Boolean, full: Boolean });
</script>

<!----------------------------------------------------------------------------->

<template>
  <div :class="{ wide, full }">
    <slot />
  </div>
</template>

<!----------------------------------------------------------------------------->

<style lang="scss" scoped>
  div {
    width: 100%;

    padding-left: $margin;
    padding-right: $margin;

    @include break-large {
      padding-left: $margin-large;
      padding-right: $margin-large;
    }

    @include break-medium {
      padding-left: $margin-medium;
      padding-right: $margin-medium;
    }

    @include break-small {
      padding-left: $margin-small;
      padding-right: $margin-small;
    }

    @include break-phone {
      padding-left: $margin-phone;
      padding-right: $margin-phone;

      &.wide {
        padding-left: $margin-phone-wide;
        padding-right: $margin-phone-wide;
      }

      &.full {
        padding-left: 0;
        padding-right: 0;
      }
    }
  }
</style>
